const s = {
  name: "PricingCards",
  dimensions: { width: 40, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 38" style="enable-background:new 0 0 40 38;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M8,10H4V8h4V10z"/>
		<path class="st0" d="M3,0C1.3,0,0,1.3,0,3v8c0,1.7,1.3,3,3,3h13c1.7,0,3-1.3,3-3V3c0-1.7-1.3-3-3-3H3z M2,3c0-0.6,0.4-1,1-1h13
			c0.6,0,1,0.4,1,1v1H2V3z M2,6h15v5c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V6z"/>
		<path class="st0" d="M4,34h2v-2H4V34z"/>
		<path class="st0" d="M7,34v-2h2v2H7z"/>
		<path class="st0" d="M3,24c-1.7,0-3,1.3-3,3v8c0,1.7,1.3,3,3,3h13c1.7,0,3-1.3,3-3v-8c0-1.7-1.3-3-3-3H3z M2,27c0-0.6,0.4-1,1-1
			h13c0.6,0,1,0.4,1,1v1H2V27z M2,30h15v5c0,0.6-0.4,1-1,1H3c-0.6,0-1-0.4-1-1V30z"/>
		<path class="st0" d="M0,20h40v-2H0V20z"/>
		<path class="st0" d="M40,28H22v-2h18V28z"/>
		<path class="st0" d="M22,32h18v-2H22V32z"/>
		<path class="st0" d="M40,36H22v-2h18V36z"/>
		<path class="st0" d="M22,4h18V2H22V4z"/>
		<path class="st0" d="M40,8H22V6h18V8z"/>
		<path class="st0" d="M22,12h18v-2H22V12z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as PricingCards
};
